jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{ variant.id }}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });
});

document.addEventListener('DOMContentLoaded', function() {
    // Verifica se estamos na página de produto
    const productPage = document.getElementById('product-page');
    
    if (productPage && productPage.getAttribute('data-page-type') === 'product') {
        // Verifica se as opções do produto contêm "Size"
        const productOptions = productPage.getAttribute('data-options').split(',');
        
        if (productOptions.includes('Size')) {
            // Cria o elemento do gráfico de tamanhos
            const sizeChartElement = document.createElement('div');
            sizeChartElement.innerHTML = "<div id='size-chart'></div>";

            // Adiciona o elemento na página (exemplo após o elemento #product-form)
            const productForm = document.querySelector('#product-form');
            if (productForm) {
                productForm.insertAdjacentElement('afterend', sizeChartElement);
            }

            // Renderiza o componente de gráfico de tamanhos (HTML exemplo)
            const sizeChart = document.getElementById('size-chart');
            if (sizeChart) {
                sizeChart.innerHTML = `
                    <h2>Size Chart</h2>
                    <p>Aqui você pode adicionar a tabela de tamanhos...</p>
                `;
            }
        }
    }
});

document.addEventListener('DOMContentLoaded', function() {
    // Identifica a página de produto e suas opções
    const productPage = document.getElementById('product-page');
    
    if (productPage) {
        const productOptions = productPage.getAttribute('data-options').split(',');

        // Verifica se as opções incluem "Size"
        if (productOptions.includes('Size')) {
            // Cria o botão "See Size Chart"
            const sizeChartButton = document.createElement('a');
            sizeChartButton.classList.add('trigger-pop-up', 'btn');
            sizeChartButton.textContent = 'See Size Chart';
            sizeChartButton.href = '#'; // Adicione o link ou função desejada aqui

            // Insere o botão na página, por exemplo, após o formulário de produto
            const productForm = document.querySelector('#product-form');
            if (productForm) {
                productForm.appendChild(sizeChartButton);
            }
        }
    }
});




